import React, { useState } from 'react';
import { chakra, Button, Container } from '@chakra-ui/react';
import LocalisedLink from './LocalisedLink';

const SubNavContent = chakra('ul', {
  baseStyle: {
    overflow: 'hidden',
    clip: 'rect(1px 1px 1px 1px) /* IE6, IE7 */, rect(1px, 1px, 1px, 1px)',
    left: '0',
    backgroundColor: '#f2f9fbf7',
    py: '10px',
    pl: ['3', '0'],
    borderRadius: '4px',
    width: '270px',
    zIndex: '1',
    listStyleImage: 'none',
    fontWeight: '400',
    a: {
      display: 'block',
      paddingBottom: '8px',
      textAlign: 'left',
      color: 'secondary',
      _hover: {
        color: 'primary',
        textDecoration: 'none',
      },
    },
    position: 'relative',
    marginLeft: '0',
    marginTop: '0',
    '@media only screen and (min-width: 1170px)': {
      position: 'absolute',
      marginTop: 'calc(1.45rem / 2)',
      padding: '8px 15px 15px',
    },
  },
});

const SingleNavItem = chakra(Container, {
  baseStyle: {
    _hover: {
      '.arrow': {
        transition: 'transform 0.5s ease-in-out',
        transform: 'rotate(180deg)',
      },
    },
    '.arrow': {
      transition: 'transform 0.5s ease-in-out',
      transform: 'rotate(0deg)',
    },
  },
});

const Arrow = chakra('div', {
  baseStyle: {
    pl: '.5rem',
  },
});

type Props = {
  buttonName: string;
  data?: {
    edges: [
      {
        node: {
          id: string;
          slug: string;
          featureName: string;
          treeChildren?: [
            {
              featureName: string;
              position: number;
              id: string;
              treeParent: { slug: string };
              slug: string;
            }
          ];
        };
      }
    ];
  };
  manualData?: any;
  home: boolean;
  location: {};
};

/** The navigation dropdown that is the the main navigation.  */
const NavDropDown = ({
  buttonName,
  data,
  manualData,
  home,
  location,
}: Props) => {
  const [focus, setFocus] = useState(false);

  function openDropDown() {
    setFocus(true);
  }

  function closeDropdown() {
    setFocus(false);
  }

  let closeDropdownTimeout;

  function startCloseTimeout() {
    closeDropdownTimeout = setTimeout(() => {
      closeDropdown();
    }, 200);
  }

  function stopCloseTimeout() {
    clearTimeout(closeDropdownTimeout);
  }

  return (
    <>
      <SingleNavItem>
        <Button
          sx={{
            background: 'transparent',
            border: 0,
            padding: 0,
            color: ['#333', home ? '#fff' : '#333333'],
            _hover: {
              backgroundColor: 'transparent',
            },
          }}
          onPointerEnter={() => {
            openDropDown();
          }}
          onPointerLeave={() => {
            location !== 'mobile' && startCloseTimeout();
          }}
          onClick={() => {
            setFocus(focus);
          }}
          // rightIcon={<NavArrows buttonName={buttonName} home={home} />}
        >
          {buttonName}{' '}
          <Arrow>
            {/* <span style={{ marginLeft: '8px' }}> */}
            <svg
              id={buttonName}
              className="arrow"
              width="18px"
              height="10px"
              viewBox="0 0 18 10"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Stroke 1 Copy</title>
              <g
                id={`2-${buttonName}`}
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <g
                  id={`3-${buttonName}`}
                  transform="translate(-775.000000, -48.000000)"
                  stroke={home ? '#fff' : '#037fb0 '}
                  strokeWidth="2"
                >
                  <polyline
                    id={`4-${buttonName}`}
                    points="792 49 784 57 776 49"
                  />
                </g>
              </g>
            </svg>
            {/* </span> */}
          </Arrow>
        </Button>
      </SingleNavItem>

      <SubNavContent
        className="subnav-content"
        sx={
          focus
            ? { clip: 'auto', display: 'block' }
            : {
                display: ['block', 'block', 'block', 'none'],
                overflow: 'scroll',
              }
        }
        onPointerEnter={() => {
          stopCloseTimeout();
        }}
        onPointerLeave={() => {
          setFocus(false);
        }}
        onFocus={() => {
          openDropDown();
        }}
      >
        {data &&
          data.edges.map(({ node }) => (
            <React.Fragment key={node.id}>
              <LocalisedLink key={node.id} tabIndex={0} to={`/${node.slug}`}>
                {node.featureName}
              </LocalisedLink>
              {node.treeChildren
                .filter((node) => node.featureName != null)
                .sort((a, b) => a.position - b.position)
                .map((node) => (
                  <LocalisedLink
                    key={node.id}
                    to={`/${node.treeParent.slug}/${node.slug}`}
                  >
                    {node.featureName}
                  </LocalisedLink>
                ))}
            </React.Fragment>
          ))}

        {manualData &&
          manualData.map((node, index) => (
            <LocalisedLink key={index} to={node.slug} noLang>
              {node.featureName}
            </LocalisedLink>
          ))}
      </SubNavContent>
    </>
  );
};

export default NavDropDown;
